import { render, staticRenderFns } from "./CuttingTab.vue?vue&type=template&id=5bc483af&scoped=true&"
import script from "./CuttingTab.vue?vue&type=script&lang=js&"
export * from "./CuttingTab.vue?vue&type=script&lang=js&"
import style1 from "./CuttingTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc483af",
  null
  
)

export default component.exports